module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLight.0facaae9.ttf";